
export default function notificationData (origin) {
  return {
    text: origin && origin.Message || '鹰眼感知监控大屏欢迎您！'
  }
}


// WEBPACK FOOTER //
// ./src/utils/formattings/notificationData.js